var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11220_56968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5176 3.75V10.5H3.76758V3.75H10.5176ZM10.5176 3H3.76758C3.56867 3 3.3779 3.07902 3.23725 3.21967C3.0966 3.36032 3.01758 3.55109 3.01758 3.75V10.5C3.01758 10.6989 3.0966 10.8897 3.23725 11.0303C3.3779 11.171 3.56867 11.25 3.76758 11.25H10.5176C10.7165 11.25 10.9073 11.171 11.0479 11.0303C11.1886 10.8897 11.2676 10.6989 11.2676 10.5V3.75C11.2676 3.55109 11.1886 3.36032 11.0479 3.21967C10.9073 3.07902 10.7165 3 10.5176 3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51758 6.75H0.767578V1.5C0.767578 1.30109 0.846596 1.11032 0.987248 0.96967C1.1279 0.829018 1.31867 0.75 1.51758 0.75H6.76758V1.5H1.51758V6.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11220_56968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.0175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySvg);
export default __webpack_public_path__ + "static/media/copy-svg.9882c172ba1f2515a1758a500e7c59c3.svg";
export { ForwardRef as ReactComponent };